import { Inject, Injectable } from '@angular/core';
import { TInputAppEnvironmentVars } from '@monorepo/types';

const BundleLineInEndPoints = {
  GET_BUNDLE_LINE_IN_TAG: 'GET_BUNDLE_LINE_IN_TAG',
  FETCH_BUNDLE_LINE_IN_RESTORE_COUNTS: 'FETCH_BUNDLE_LINE_IN_RESTORE_COUNTS',
  SAVE_BUNDLE_LINE_IN_EVENT: 'SAVE_BUNDLE_LINE_IN_EVENT',

  GET_BUNDLE_LINE_IN_AVAILABLE_WIP: 'GET_BUNDLE_LINE_IN_AVAILABLE_WIP',
  GET_BUNDLE_LINE_IN_TRANSACTION_LOG: 'GET_BUNDLE_LINE_IN_TRANSACTION_LOG',
  GET_BUNDLE_LINE_IN_ACTIVITY_LOG: 'GET_BUNDLE_LINE_IN_ACTIVITY_LOG',
};

type TBundleLineInEndPoints = typeof BundleLineInEndPoints;
type TBundleLineInEndPointsTypes = keyof TBundleLineInEndPoints;
type TEnvVariables = TBundleLineInEndPoints;

@Injectable({
  providedIn: 'root',
})
export class BundleLineInEnvProvider {
  private env_vars!: TEnvVariables;
  private protocol = 'http';
  private service_host = '';
  private tags_services = '';
  private event_hub = '';

  constructor(@Inject('environment') ENV: TInputAppEnvironmentVars) {
    if (ENV.protocol !== null) {
      this.protocol = ENV.protocol;
    }
    if (ENV.service_host !== null) {
      this.service_host = ENV.service_host;
    }
    if (ENV.tags_services !== null) {
      this.tags_services = ENV.tags_services;
    }
    if (ENV.event_hub !== null) {
      this.event_hub = ENV.event_hub;
    }
    this.registerVars();
  }

  registerVars() {
    const HOST_DOMAIN_WITH_PROTOCOL = this.protocol + this.service_host;
    const TAGS_SERVICE_URL = HOST_DOMAIN_WITH_PROTOCOL + this.tags_services;
    const EVENT_HUB_URL = HOST_DOMAIN_WITH_PROTOCOL + this.event_hub;

    this.env_vars = {
      GET_BUNDLE_LINE_IN_TAG: `${TAGS_SERVICE_URL}/tags/getCutTagByDisplayCutTagId`,
      SAVE_BUNDLE_LINE_IN_EVENT: `${EVENT_HUB_URL}/api/v3/event/save`,
      FETCH_BUNDLE_LINE_IN_RESTORE_COUNTS: `${EVENT_HUB_URL}/api/v1/bundle/logs/restorecount`,

      GET_BUNDLE_LINE_IN_TRANSACTION_LOG: `${EVENT_HUB_URL}/api/v1/bundle/logs/transaction`,
      GET_BUNDLE_LINE_IN_ACTIVITY_LOG: `${EVENT_HUB_URL}/api/v1/bundle/logs/activity`,
      GET_BUNDLE_LINE_IN_AVAILABLE_WIP: `${EVENT_HUB_URL}/api/bundle/availableWip`,
    };
  }

  getEnvVar(key: TBundleLineInEndPointsTypes): string {
    return this.env_vars[key];
  }
}
